import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "./slices/adminSlice";
import categoryReducer from "./slices/categorySlice";
import brandReducer from "./slices/brandSlice";
import productReducer from "./slices/productSlice";
import bannerReducer from "./slices/bannerSlice";
import articleReducer from "./slices/articleSlice";
import pageReducer from "./slices/pageSlice";
import orderReducer from "./slices/orderSlice";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    category: categoryReducer,
    brand: brandReducer,
    product: productReducer,
    banner: bannerReducer,
    article: articleReducer,
    page: pageReducer,
    order: orderReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
